module.exports = __webpack_public_path__ + "img/search_no.3c3c5eec.png";